import { HEIGHT } from '../constants.js';
import {
  EmailIcon,
  EmailShareButton,
  TelegramIcon,
  TelegramShareButton,
  ViberIcon,
  ViberShareButton,
  VKIcon,
  VKShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from 'react-share';

export interface ShareButtonsProps {
  url: string;
}

/** Кнопки «поделиться» — перенос shareButtons (AppFCFun.kt:17-55). */
export function ShareButtons({ url }: ShareButtonsProps) {
  const size = HEIGHT;

  return (
    <>
      <EmailShareButton url={url}>
        <EmailIcon size={size} round />
      </EmailShareButton>
      <TelegramShareButton url={url}>
        <TelegramIcon size={size} round />
      </TelegramShareButton>
      <ViberShareButton url={url}>
        <ViberIcon size={size} round />
      </ViberShareButton>
      <VKShareButton url={url}>
        <VKIcon size={size} round />
      </VKShareButton>
      <WhatsappShareButton url={url}>
        <WhatsappIcon size={size} round />
      </WhatsappShareButton>
    </>
  );
}
